let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a5MOw")).then(() => parcelRequire('fdbBG'));